import { render, staticRenderFns } from "./AppTeste.vue?vue&type=template&id=0bac1672&"
import script from "./AppTeste.vue?vue&type=script&lang=js&"
export * from "./AppTeste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports